import React, { useState } from "react";
import PropTypes from "prop-types";

import Modal from "core/Modal";
import BodyText from "core/BodyText";

import { StageLink } from "./styles";

const EditModal = ({ modalHeading, fileName, children }) => {
    const [isOpen, setOpen] = useState(false);

    const openModal = e => {
        e.preventDefault();
        setOpen(true);
    };

    const closeModal = e => {
        e.preventDefault();
        setOpen(false);
    };

    return (
        <>
            <BodyText size="md" type="div">
                <StageLink
                    aria-label={`Edit file name "${fileName}"`}
                    as="button"
                    onClick={e => openModal(e)}
                >
                    Edit
                </StageLink>
            </BodyText>

            <Modal
                open={isOpen}
                onClose={e => closeModal(e)}
                handleClose={e => closeModal(e)}
                heading={modalHeading}
            >
                {children}
            </Modal>
        </>
    );
};

EditModal.propTypes = {
    modalHeading: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired
};

export default EditModal;
